import React from 'react'

function Footer() {
  return (
    <footer>
        <div className="waves">
            <div className="wave" id="wave1"></div>
            <div className="wave" id="wave2"></div>
            <div className="wave" id="wave3"></div>
            <div className="wave" id="wave4"></div>
        </div>
        <p>© 2022 - Damien Gouron | All Rights Reserved | Version 0.0.1 Bêta | <a href="https://dgouron.fr" target="_blank" rel="noreferrer">Contact</a></p>
    </footer>
  )
}

export default Footer